import "./css/app.css";
import "./css/main.css";
import "./css/common.css";
import "./css/mobile.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { change_Current_Location, changeHeaderTitle } from "../store";

export default function UrlComplete() {
    const dispatch = useDispatch();
    const { state } = useLocation();

    // ✅ MidLayout에서 이미 가드됨. 여기서는 디코딩만 해서 사용.
    const { mid: rawMid } = useParams();
    const mid = rawMid ? decodeURIComponent(rawMid) : "";

    const login = useSelector((s) => s.login?.value);
    useEffect(() => {
        // MidLayout에서 이미 유효성/세션 체크 완료.
    }, [mid, login]);

    const fmt = (n) =>
        typeof n === "number"
            ? n.toLocaleString("ko-KR")
            : (Number(n) || 0).toLocaleString("ko-KR");

    // ===== 목업 기본값 =====
    const mock = {
        orderId: "ORD-20250912-0001",
        orderedAt: new Date().toISOString(),
        buyer: {
            name: "강재원(집)",
            tel: "010-7284-7899",
            address1: "경기도 수원시 장안구 장안로 271 (정자동) 115-705",
            postcode: "16336",
        },
        items: [
            {
                merchantName: "보넬드",
                productName:
                    "[100% NFC 토마토 14개 착즙] 보넬드 아이엠 토마토 주스 즙 원액 1L, 3개",
                quantity: 1,
                unitPrice: 23000,
                originalUnit: 23000,
                thumbnail: "https://picsum.photos/id/1080/1200/900",
                optionText: "수량",
            },
        ],
        deliveryFee: 0,
        subtotal: 23000,
        total: 23000,
        payment: {
            method: "신용카드",
            cardMasked: "하나 9416 **** **** ****",
            payType: "일시불",
            email: "wodnjs***@naver.com",
        },
        cashReceipt: { issued: true, type: "소득공제용", info: "010-****-****" },
    };

    // 외부값 병합 (UrlPayment에서 state로 넘겨준 영수증 등)
    const data = { ...mock, ...(state?.receipt || {}) };
    const item = data.items?.[0] || {};
    const itemsCount = data.items?.length || 0;

    // 파생 값
    const displayName = String(data.buyer?.name || "").replace(/\(.*?\)/g, "");
    const quantity = Number(item.quantity ?? 1);
    const unitPrice = Number(item.unitPrice ?? 0);
    const originalUnit = Number(item.originalUnit ?? unitPrice);
    const hasDiscount = originalUnit > unitPrice;
    const productAmount = unitPrice * quantity;
    const deliveryFee = Number(data.deliveryFee || 0);
    const subtotal = Number(data.subtotal ?? productAmount);
    const totalAmount =
        typeof data.total === "number" ? Number(data.total) : subtotal + deliveryFee;
    const discount = subtotal + deliveryFee - totalAmount;

    useEffect(() => {
        dispatch(change_Current_Location("주문완료"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "주문완료",
                subTitle: "",
            })
        );
    }, [dispatch]);

    const formatOrderDate = (iso) => {
        const d = new Date(iso);
        if (isNaN(d)) return "";
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        const HH = String(d.getHours()).padStart(2, "0");
        const MM = String(d.getMinutes()).padStart(2, "0");
        const SS = String(d.getSeconds()).padStart(2, "0");
        return `${yyyy}.${mm}.${dd}. ${HH}:${MM}:${SS}`;
    };

    const showDiscount = discount > 0.0001;

    return (
        <div className="urlComplete-wrap">
            <div className="urlComplete-hero">
                <div className="urlComplete-heroTitle">
                    <span className="urlComplete-heroEmph">주문완료</span> 되었습니다
                </div>
            </div>

            <div className="urlComplete-page">
                <div className="urlComplete-single">
                    {/* 주문번호 */}
                    <div className="urlComplete-block">
                        <div className="urlComplete-row" style={{ margin: "3px 0 0" }}>
                            <div className="urlComplete-label">주문번호</div>
                            <div className="urlComplete-orderId">{data.orderId}</div>
                        </div>
                    </div>
                    <div className="urlComplete-hr" />

                    {/* 배송지 */}
                    <div className="urlComplete-block">
                        <div className="urlComplete-buyerName">{displayName}</div>
                        <div className="urlComplete-buyerAddr">
                            {data.buyer.address1} ({data.buyer.postcode}) , {data.buyer.tel}
                        </div>
                    </div>
                    <div className="urlComplete-hr" />

                    {/* 주문상품 */}
                    <div className="urlComplete-block">
                        <div className="urlComplete-title">
                            주문상품 {itemsCount ? `${itemsCount}건` : ""}
                        </div>

                        <div className="urlComplete-item">
                            <div className="urlComplete-thumb">
                                {item.thumbnail ? (
                                    <img src={item.thumbnail} alt="" className="urlComplete-thumbImg" />
                                ) : null}
                            </div>

                            <div className="urlComplete-itemInfo">
                                <div className="urlComplete-prodName">{item.productName || "상품명"}</div>
                                <div className="urlComplete-optionRow">
                                    <span className="urlComplete-optionText">
                                        {item.optionText || "선택 없음"} | {quantity}개
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="urlComplete-hr" />

                    {/* 주문금액 */}
                    <div className="urlComplete-block">
                        <div className="urlComplete-row urlComplete-amountTop">
                            <div className="urlComplete-title">주문금액</div>
                            <div className="urlComplete-amountTotal">{fmt(totalAmount)}원</div>
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-muted">상품금액</div>
                            <div className="urlComplete-amount">{fmt(subtotal)}원</div>
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-muted">배송비</div>
                            <div className="urlComplete-amount">{fmt(data.deliveryFee || 0)}원</div>
                        </div>

                        {showDiscount && (
                            <div className="urlComplete-row">
                                <div className="urlComplete-muted">할인/쿠폰</div>
                                <div className="urlComplete-amount">-{fmt(discount)}원</div>
                            </div>
                        )}
                    </div>
                    <div className="urlComplete-hr" />

                    {/* 결제상세 */}
                    <div className="urlComplete-block">
                        <div className="urlComplete-title" style={{ marginBottom: "15px" }}>
                            결제상세
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-label">신용카드</div>
                            <div className="urlComplete-value">
                                {String(data.payment.cardMasked)
                                    .replace(/\s+/g, " ")
                                    .replace(/\s/g, "-")
                                    .replace(/-+/g, "-")}
                                {" , "}
                                {data.payment.payType}
                            </div>
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-label">승인일시</div>
                            <div className="urlComplete-value">{formatOrderDate(data.orderedAt)}</div>
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-label">이메일</div>
                            <div className="urlComplete-value">{data.payment.email}</div>
                        </div>

                        <div className="urlComplete-row">
                            <div className="urlComplete-label">현금영수증</div>
                            <div className="urlComplete-value">
                                {data.cashReceipt?.issued
                                    ? `발급 (${data.cashReceipt.type}, ${data.cashReceipt.info})`
                                    : "미발급"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
